<template>
  <div>
    <ul class="sa-card-list">
      <li v-for="(n, i) in apList" :key="i">
        <div class="sa-card-list-box" @click="docDet(n.apnt_id)">
          <figure class="sa-avt-img">
            <img v-if="n.img" :src="n.img" alt="Doctor" class="sa-img-cover" />
            <img v-else :src="unknownImg" alt="Doctor" class="sa-img-cover" />
          </figure>
          <div class="sa-doct-det">
            <h6>{{ n.pname }}</h6>
            {{ n.st_nm }}
          </div>
          <div class="sa-doct-apoint">
            Appointment ID : {{ n.apnt_id }}
            <span class="sa-doct-apoint-time sa-green-text">
              {{ n.time }}
              <dfn>{{ n.strt_tym }}</dfn>
            </span>
          </div>
        </div>
        <div class="sa-ins-apt">
          <span v-if="n && n.refil" class="sa-refill">Refill</span>
          <span class="sa-bupa-str" v-else-if="n && n.sales_channel == 'bupa'"
            ><i class="icon-Insurance2"></i> Bupa Appointment</span
          >
        </div>
        <!-- <div class="sa-card-list-box2">
           Ph : +{{n.pc}} {{n.ph}} 
           <button class="sa-btn sa-btn-primary">Start chat <i class="icon-chat sa-white-text"></i></button>
        </div> -->
      </li>
    </ul>
    <ul class="sa-pagination" v-if="totalpages > 1">
      <li class="sa-p-item">
        <a class="sa-p-link" v-if="currentPage != 1" @click="currentPage--">
          <i class="icon-left-arrow"></i>
        </a>
      </li>
      <li
        class="sa-p-item"
        v-for="i in pages.slice(currentPage - 1, currentPage + 5)"
        :key="i"
        :class="{ active: i == currentPage }"
      >
        <a class="sa-p-link" @click="currentPage = i"> {{ i }} </a>
      </li>
      <li class="sa-p-item">
        <a
          @click="currentPage++"
          v-if="currentPage < pages.length"
          class="sa-p-link"
        >
          <i class="icon-right-arrow"></i>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: ["apList", "totalpages", "currentPage"],
  components: {},
  data() {
    return {
      pageRange: 5,
      pages: [],
      unknownImg: "https://img.litedev.com/images/unknown-avtar.png",
    };
  },
  watch: {
    totalpages: {
      immediate: true,
      deep: true,
      handler() {
        this.pages = [];
        for (let index = 1; index <= this.totalpages; index++) {
          this.pages.push(index);
        }
      },
    },
    currentPage: {
      immediate: false,
      deep: true,
      handler() {
        this.$parent.getList(this.currentPage);
      },
    },
  },
  methods: {
    docDet(aid) {
      let _self = this;
      _self.$router.push({
        path: "/appointments/doctor-details/review-diagnosis/" + aid,
      });
    },
  },
};
</script>